export function throwIfModuleAlreadyLoaded(parent: any, name: string, destination: string = 'AppModule') {
  if (parent) {
    throw new Error(`${name} has already been loaded. Import ${name} in the ${destination} only.`);
  }
}
